export default __webpack_public_path__ + "static/media/gcloud.010d8ff6.svg";